var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVendasColorido(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_458_4039)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4856 18.1258C28.1836 17.9581 27.8164 17.9581 27.5144 18.1258L18.5144 23.1258C18.0316 23.394 17.8576 24.0028 18.1258 24.4856C18.3941 24.9684 19.0029 25.1423 19.4856 24.8741L28 20.1439L34.9409 23.9999L27.5144 28.1258C27.1969 28.3021 27 28.6367 27 28.9999V36.9998C27 37.3541 27.1875 37.682 27.4929 37.8617C27.7983 38.0414 28.1759 38.046 28.4856 37.874L37.4856 32.874C37.8031 32.6977 38 32.363 38 31.9999V24.0199C38.0014 23.9491 37.9951 23.8785 37.9817 23.8095C37.9718 23.7583 37.9579 23.7082 37.9403 23.6596C37.8614 23.4414 37.7067 23.2495 37.4885 23.1274M28.4856 18.1258L37.4845 23.1252ZM36 31.4115V25.6994L29 29.5883V35.3003L36 31.4115Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 23C19.5523 23 20 23.4477 20 23.9999V31.4115L28.4856 36.1257C28.9684 36.3939 29.1424 37.0027 28.8742 37.4855C28.6059 37.9682 27.9971 38.1422 27.5144 37.874L18.5144 32.874C18.1969 32.6977 18 32.363 18 31.9999V23.9999C18 23.4477 18.4477 23 19 23Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1258 23.5143C18.3941 23.0315 19.0029 22.8576 19.4856 23.1258L28.4856 28.1257C28.9684 28.394 29.1424 29.0028 28.8742 29.4855C28.6059 29.9683 27.9971 30.1423 27.5144 29.874L18.5144 24.8741C18.0316 24.6059 17.8576 23.9971 18.1258 23.5143Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_4039",
    x1: 0,
    y1: 28,
    x2: 56,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF914C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendasColorido);
export default __webpack_public_path__ + "static/media/vendasColorido.0d49c04e6dde7c3b6dd3b51a69b20288.svg";
export { ForwardRef as ReactComponent };